// Utils
import { sendGetRequest } from "../utils/api/apiUtils";

// Urls
import { getOrgRouteTypesUrl } from "../urls/OrgRouteTypesURL";

export async function getRouteTypesFn(cityId) {
  const params = {
    _city: cityId,
  };

  return sendGetRequest(getOrgRouteTypesUrl, params);
}
